import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TrainingGuide {
  guideId: number;
  systemKey: string;
  title: string;
  shortDescription: string | null;
  guideType: 'text' | 'pdf' | 'pptx' | 'video';
  sourceMode: 'text' | 'link' | 's3';
  textContent: string | null;
  fileUrl: string | null;
  sortOrder: number;
}

@Injectable({ providedIn: 'root' })
export class TrainingGuidesService {
  constructor(private http: HttpClient) {}

  getGuides(): Observable<TrainingGuide[]> {
    return this.http.get<TrainingGuide[]>('/api/training-guides');
  }
}
